import { fabric } from 'fabric';
import Vec2 from 'vec2';

import {
  CANVAS_OBJECT_TYPE_PREFIX,
  EDGE_STROKE_WIDTH,
  SELECTION_CIRCLE_OPACITY,
} from '~/core/constants';
import { DrawingEdge } from '~/core/models';
import theme from '~/theme/theme';

const {
  drawingTool: { secondaryBorderColor },
} = theme.light;

export const createBumpOutPath = (
  edge: DrawingEdge,
  bumpVec: Vec2[],
  forClipping: boolean,
  useOverlay: boolean
) => {
  const firstPathPortion = !forClipping
    ? edge.startDisplayVec.x.toString() +
      ' ' +
      edge.startDisplayVec.y.toString() +
      ' L '
    : '';

  const lastPathPortion = !forClipping
    ? ' L ' +
      edge.endDisplayVec.x.toString() +
      ' ' +
      edge.endDisplayVec.y.toString()
    : ' Z';

  let pathString = 'M ' + firstPathPortion;

  for (let b = 0; b < 4; b++) {
    pathString =
      pathString +
      bumpVec[b].x.toString() +
      ' ' +
      bumpVec[b].y.toString() +
      (b < 3 ? ' L ' : '');
  }
  pathString = pathString + lastPathPortion;

  const pathOptions = forClipping
    ? {}
    : {
        stroke: secondaryBorderColor,
        strokeWidth: EDGE_STROKE_WIDTH,
        fill: useOverlay ? secondaryBorderColor : 'transparent',
        opacity: useOverlay ? SELECTION_CIRCLE_OPACITY : 1,
        name: `${CANVAS_OBJECT_TYPE_PREFIX.BUMP_OUT}_${edge.id}`,
      };

  return new fabric.Path(pathString, pathOptions);
};
